
import { Component, Input } from '@angular/core';
import {SlideshowService} from './../../slideshow.service';

@Component({
    selector: 'content',
    templateUrl: 'content.component.html'
})
export class PreviewContentComponent {
    @Input('device') device;
    constructor(private slideshow: SlideshowService) {}
    getMobileSrc(slide) {
        let image;
        if( slide.images.length > 0 ) {
            image = slide.images[0];
        }
        if( slide.imagesMobile.length > 0 ) {
            image = slide.imagesMobile[0];
        }
        if( image ) {
            return image.sizes.mobile ? image.sizes.mobile.urlWithParams : image.sizes.medium.urlWithParams;
        }
        return '';
    }
}


// WEBPACK FOOTER //
// /opt/atlassian/pipelines/agent/build/src/swarm/src/app/slideshow/tabs/preview/content.component.ts